import { AbstractService } from "./ApiClient";
import { ApiRoutes } from "@typingsGenerator/ApiRoutes";
import BackupDirectoryResponseDto = Cloud.RavenDB.Core.Dto.Backups.BackupDirectoryResponseDto;
import BackupEncryptionKeyDto = Cloud.RavenDB.Core.Dto.Backups.BackupEncryptionKeyDto;
import BackupProductListDto = Cloud.RavenDB.Core.Dto.Backups.BackupProductListDto;
import BackupLinksInfoDto = Cloud.RavenDB.Core.Dto.Backups.BackupLinksInfoDto;
import BackupDownloadLinksResponseDto = Cloud.RavenDB.Core.Dto.Backups.BackupDownloadLinksResponseDto;
import { DownloadBackupModalData } from "../components/pages/portal/backups/DownloadBackupsModal";

export default class BackupsService extends AbstractService {
    getBackupList = async (
        domainName: string,
        productId: string,
        prefix: string
    ): Promise<BackupDirectoryResponseDto> => {
        const products = await this.query<{ productId: string; prefix: string }, BackupDirectoryResponseDto>(
            ApiRoutes.backup.listBackupDirectory({ domainName }),
            { productId, prefix }
        );
        return products.data;
    };

    getBackupCredentials = async (
        domainName: string,
        productId: string,
        databaseName: string,
        innerPath: string,
        durationInHours: number
    ): Promise<string> => {
        const response = await this.query<
            { productId: string; databaseName: string; innerPath: string; durationInHours: number },
            { link: string }
        >(ApiRoutes.backup.getReadonlyBackupCredentialsLink({ domainName }), {
            databaseName,
            productId,
            innerPath,
            durationInHours,
        });

        return response.data.link;
    };

    getBackupEncryptionKey = async (domainName: string): Promise<BackupEncryptionKeyDto> => {
        const response = await this.query<BackupEncryptionKeyDto>(
            ApiRoutes.backup.getEncryptionKeyForBackups({ domainName })
        );
        return response.data;
    };

    getProducts = async (domainName: string): Promise<BackupProductListDto> => {
        const response = await this.query<BackupProductListDto>(ApiRoutes.backup.getProducts({ domainName }));
        return response.data;
    };

    revokeAllBackupLinks = async (domainName: string): Promise<void> => {
        await this.delete<void>(ApiRoutes.backup.clearBackupCredentialsLinks({ domainName }));
    };

    loadActiveLinksCount = async (domainName: string): Promise<number> => {
        const response = await this.query<BackupLinksInfoDto>(ApiRoutes.backup.getBackupLinksInfo({ domainName }));
        return response.data.count;
    };

    getBackupDownloadLink = async (data: DownloadBackupModalData): Promise<BackupDownloadLinksResponseDto> => {
        const { domainName, databaseName, productId, innerPath } = data;

        const response = await this.query<
            { productId: string; databaseName: string; innerPath: string },
            BackupDownloadLinksResponseDto
        >(ApiRoutes.backup.getBackupDownloadLinks({ domainName }), { databaseName, productId, innerPath });
        return response.data;
    };
}
